<template>
  <div class="page">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__hd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">单号</label>
            <em class="weui-form-preview__value">{{form.main.sa_code}}</em>
          </div>
        </div>
        <custom-layout class="weui-form-preview__bd" :view-config="customViewConfig">
          <div class="weui-form-preview__item" v-if="form.main.sa_name" slot="sa_name">
            <label class="weui-form-preview__label">{{customLabel.sa_name || "抽样标准"}}</label>
            <em class="weui-form-preview__value">{{form.main.sa_name}}</em>
          </div>
          <div class="weui-form-preview__item" v-if="form.main.sa_remark" slot="sa_remark">
            <label class="weui-form-preview__label">{{customLabel.sa_remark || "备注"}}</label>
            <span class="weui-form-preview__value">{{form.main.sa_remark}}</span>
          </div>
         
          <div class="weui-form-preview__item" slot="sa_default">
            <label class="weui-form-preview__label">{{customLabel.sa_default || "默认"}}</label>
            <span class="weui-form-preview__value">{{form.main.sa_default ? '是' : '否'}}</span>
          </div>
        </custom-layout>
      </div>

      <div class="form-preview weui-form-preview">
        <div
          class="weui-form-preview__bd form-detail-preview"
          v-for="item in form.items"
          :key="item.id"
        >
          <div class="form-detail-preview_num">{{item.sd_detno}}</div>
          <custom-layout :view-config="customViewConfig" position="detail1">
          
          <div class="weui-form-preview__item" v-if="item.sd_min" slot="sd_min"> 
            <label class="weui-form-preview__label">{{customLabel.sd_min || "最小值"}}</label>
            <span class="weui-form-preview__value">{{item.sd_min}}</span>
          </div>
          <div class="weui-form-preview__item" v-if="item.sd_max" slot="sd_max">
            <label class="weui-form-preview__label">{{customLabel.sd_max || "最大值"}}</label>
            <span class="weui-form-preview__value">{{item.sd_max}}</span>
          </div>
          <div class="weui-form-preview__item" v-if="item.sd_qty" slot="sd_qty">
            <label class="weui-form-preview__label">{{customLabel.sd_qty || "抽样数"}}</label>
            <span class="weui-form-preview__value">{{item.sd_qty}}</span>
          </div>
          </custom-layout>
        </div>
      </div>

      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item" v-if="form.main.creatorName">
            <label class="weui-form-preview__label">{{customLabel.creatorName || "录入人"}}</label>
            <span class="weui-form-preview__value">{{form.main.creatorName}}</span>
          </div>
          <div class="weui-form-preview__item" v-if="form.main.createTime">
            <label class="weui-form-preview__label">{{customLabel.createTime || "录入日期"}}</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{form.main.createTime}}</span>
          </div>
        </div>
      </div>
    </div> 
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import form from "@/mixins/form.js";

export default {
  mixins: [form],
   components: {
    CustomLayout,
  },
  data() {
    return {
      baseUrl: "/api/storage/qcsample",
      caller:'qcSample',
      xtype:'stock-qcSample-formpanel'
    };
  }
};
</script>